import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { GenericSnackBarComponent } from '../components/generic-snack-bar/generic-snack-bar.component';
import { DataSnackBar } from '../models/snackbar-data';


@Injectable({
  providedIn: 'root'
})
export class SnackBarService {

  constructor(private snackBar: MatSnackBar) { }

  openSnackBar(snackBarData: DataSnackBar) {
    this.snackBar.openFromComponent(GenericSnackBarComponent, {
      data: snackBarData,
      duration: 3000,
      verticalPosition: 'top',
      horizontalPosition: 'end',
      panelClass: [snackBarData.snackBarTheme]
    });
  }

}
